import { offerCodeEnum } from '../../../../views/_common/enums/offerCodeEnum.js';

const shouldSkipSimulationNeeds = (context) =>
  [
    offerCodeEnum.INDIVIDUAL_HEALTH,
    offerCodeEnum.GROUP_HEALTH,
    offerCodeEnum.SELF_EMPLOYED_WORKER_PROTECTION
  ].includes(context?.offerCode) &&
  (context?.activeUserRoles ?? []).includes('BROKER');

export default shouldSkipSimulationNeeds;
